import React from 'react';
import { Spring, animated } from 'react-spring';
import debounce from 'lodash.debounce';

import routes from '../../routes';

import styles from './style.css';

const pageOrder = routes
  .filter(({ standalone }) => !standalone)
  .map(route => route.path);

class Scroller extends React.Component {
  constructor(props) {
    super(props);

    this.goToPage = debounce(this.goToPage, 500, {
      leading: true,
      trailing: false,
      maxWait: 1500
    });
  }

  componentDidMount() {
    this.Hammer = require('hammerjs'); // eslint-disable-line
    this.hammer = new this.Hammer.Manager(document.body);

    const {
      location: { pathname }
    } = this.props;

    if (pathname !== '/contact') {
      this.addSwipeDetection();
    }

    this.hammer.on('swipe', e => {
      this.goToPage(-e.deltaY);
    });

    window.addEventListener(
      'wheel',
      e => {
        this.goToPage(e.deltaY);
      },
      false
    );
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname }
    } = this.props;

    if (pathname === '/contact') {
      this.removeSwipeDetection();
    } else if (prevProps.location.pathname === '/contact') {
      this.addSwipeDetection();
    }
  }

  addSwipeDetection() {
    this.hammer.add(
      new this.Hammer.Swipe({ direction: this.Hammer.DIRECTION_VERTICAL })
    );
  }

  removeSwipeDetection() {
    this.hammer.remove('swipe');
  }

  goToPage(delta) {
    const direction = Math.sign(delta);

    const {
      location: { pathname },
      history
    } = this.props;

    if (pathname.indexOf('/jobs') !== -1) {
      return;
    }

    const nextLocation = pageOrder[pageOrder.indexOf(pathname) + direction];

    if (nextLocation) {
      history.push(nextLocation);
    }
  }

  render() {
    const { style } = this.props;

    return (
      <Spring native to={style}>
        {computedStyle => (
          <animated.div style={computedStyle} className={styles.scroller}>
            <div className={styles.scroller__inner}>
              <div className={styles.scroller__text}>scroll</div>
              <div className={styles.scroller__block} />
            </div>
          </animated.div>
        )}
      </Spring>
    );
  }
}

export default Scroller;
